(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sb-language-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function (event) {
    if (event.target.matches('.sb-language-selector select')) event.target.form.requestSubmit();
  });
  } catch(e) { console.error(e); }
})();

})();
